import BeveledEdgeRepeatSvg from './BeveledEdgeRepeatSvg';

export default BeveledEdgeRepeatSvg;
export { BeveledEdgeRepeatSvg };
